import React from 'react';
import AllRoute from '../router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Analytics } from "@vercel/analytics/react"


const App = () => {

  return (
    <div className="App" id='Home'>
      <AllRoute />
      <ToastContainer />
      <Analytics/>
    </div>
  );
}

export default App;